import { useCallback } from 'react';
import { useAuthContext } from '../modules/login/AuthContext';
import { useFindUserContextPreferences } from '../services/modules/userContextPreferences/userContextPreferences.queries';
import {
  ColumnsPreferenceRecognizedLists,
  DefaultView,
  FilterPreferenceRecognizedLists,
  UiPreferenceRecognizedKeys,
} from '../services/modules/userContextPreferences/userContextPreferences.types';

// TODO: ANTIGAMENTE ISSO ERA UM CONTEXTO, AGORA É UM HOOK, PODEMOS CRIAR UMA PASTA DENTRO DE modules PARA userContextPreferences E MOVER TUDO RELACIONADO A ESSA FEATURE PARA LÁ
export const useUserContextPreferences = () => {
  const { loggedin } = useAuthContext();
  const {
    data: userContextPreferences,
    isSuccess: hasFetchedUserPreferences,
    isError,
    isFetching,
  } = useFindUserContextPreferences({ enabled: loggedin });

  const hasSettledUserPreferences = hasFetchedUserPreferences || isError;

  const getDefaultFiltersToList = useCallback(
    (list: FilterPreferenceRecognizedLists) => {
      const filterPreferencesToList = userContextPreferences?.filterPreferences?.find(
        (listPreference) => listPreference.list === list,
      );
      if (!filterPreferencesToList) {
        return null;
      }
      return filterPreferencesToList.defaultFilters;
    },
    [userContextPreferences],
  );

  const getDefaultColumnsToList = useCallback(
    (list: ColumnsPreferenceRecognizedLists) => {
      const filterPreferencesToList = userContextPreferences?.columnsPreferences?.find(
        (listPreference) => listPreference.list === list,
      );
      if (!filterPreferencesToList) {
        return null;
      }
      return filterPreferencesToList.defaultColumns;
    },
    [userContextPreferences],
  );

  const getUiPreferenceValue = (key: UiPreferenceRecognizedKeys) =>
    userContextPreferences?.uiPreferences?.find((preference) => preference.key === key)?.value ??
    null;

  const getDefaultCatalogView = () =>
    getUiPreferenceValue(UiPreferenceRecognizedKeys.CATALOG_VIEW) as DefaultView | null;

  return {
    getDefaultFiltersToList,
    userContextPreferences,
    hasFetchedUserPreferences,
    getDefaultColumnsToList,
    getDefaultCatalogView,
    getUiPreferenceValue,
    hasSettledUserPreferences,
    isFetching,
  };
};
